import { STATIC_VALUE } from './../../shared/configuration/static.value';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { Component, OnInit, Inject, HostListener } from '@angular/core';

@Component({
	selector: 'information-faq',
	templateUrl: 'faq.component.html'
})

export class InformationFaqComponent {

    vLoadData: boolean = false;

	vAccor: any[];
    vCurrentAccor: number;
    vExpandStatus = [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true];
	constructor(    
        private _pageNavigationService: PageNavigationService,
        private _layoutService: LayoutService
    ){}

    ngOnInit(){
        this._layoutService.setCurrentPage('information-faq');
    }	    
    //Added by Anjaiah 
    windowScrolled: boolean;
    @HostListener("window:scroll", [])
    onWindowScroll() {
        if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
            this.windowScrolled = true;
        } 
       else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
            this.windowScrolled = false;
        }
    }
    ngAfterViewInit(){
        ['dig7', 'dig24'].forEach(x => {
            let element = document.getElementById(x);
            let existingData = element. innerHTML
            element.innerHTML = this.replaceGlobally(existingData, '#EMAIL#', '<span style="color:blue;">prpnce-admin@netlinknbn.com</span>')
        })
      
    }
    goToLogin(){
        let vLink = ['login'];
        this._pageNavigationService.navigate(vLink);
    }
    //Added by Anjaiah
    replaceGlobally(original, searchTxt, replaceTxt) {
        const regex = new RegExp(searchTxt);
        return original.replace(regex, replaceTxt);
    }

    getFAQList() {

		return STATIC_VALUE.FAQ_LIST;
    }
    
    getExpandStatus(){
        return this.vExpandStatus;
    }

	//click open/expand status faq, event from html (click)
	changeExpandedStatus(pIndex) {
        let faqList = [] = this.getFAQList();
        this.vCurrentAccor = pIndex;
        faqList[pIndex].expandStatus = !faqList[pIndex].expandStatus;
    }
    scrollToTop() {
        //alert();
        (function smoothscroll() {
           // alert(1);
            var elmnt = document.getElementById("myDIV");
            elmnt.scrollLeft = 50;
            elmnt.scrollTop = 10;
            /*var currentScroll = elmnt.scrollTop || document.body.scrollTop;
            alert(2+' '+currentScroll);

            if (currentScroll > 0) {
                alert(3);

                window.requestAnimationFrame(smoothscroll);
                window.scrollTo(0, currentScroll - (currentScroll / 8));
                alert(24);

            }*/
        })();
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/information/components/faq.component.ts